import { render, staticRenderFns } from "./BlendedIcon.vue?vue&type=template&id=a70247a2&scoped=true"
import script from "./BlendedIcon.vue?vue&type=script&lang=js"
export * from "./BlendedIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a70247a2",
  null
  
)

export default component.exports